import { render, staticRenderFns } from "./FormSuccess.vue?vue&type=template&id=6d3d0293"
import script from "./FormSuccess.vue?vue&type=script&lang=js"
export * from "./FormSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports